export default __webpack_public_path__ + "static/media/hardhat.c5aeb543.webp";